import * as React from 'react';
import { SiteHeaderLayout } from '../entities/site-header-layout';
export var SiteHeaderDefaultState = {
  isLangMenuVisible: false,
  isShareMenuVisible: false,
  isMenuBarVisible: false,
  isNavigationMenuVisible: false,
  isPinnedNavigationMenuVisible: false,
  isContactUsMenuVisible: false,
  disclosedMenuItem: ''
};
export var SiteHeaderDefaultConfig = {
  component: SiteHeaderLayout,
  defaultState: SiteHeaderDefaultState
};
export var SiteHeaderContext = React.createContext(SiteHeaderDefaultConfig);
export var SiteHeaderProvider = SiteHeaderContext.Provider;